import React from "react";
import { Flex } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";

var MessageDropdown = function MessageDropdown(_ref) {
  var isError = _ref.isError,
      children = _ref.children;
  return ___EmotionJSX(Flex, {
    width: "100%",
    position: "absolute",
    backgroundColor: "white",
    color: isError ? "error" : "secondary",
    fontSize: "xs",
    borderTop: "1px solid",
    padding: "7px",
    borderBottomLeftRadius: "4px",
    borderBottomRightRadius: "4px",
    boxShadow: "dropDown",
    role: "dialog",
    "aria-label": "Message Dropdown"
  }, children);
};

export default MessageDropdown;